export default "__VITE_ASSET__D_fH2cXy__"